package ru.villawonka.app.presentation.design.components

import androidx.compose.foundation.interaction.MutableInteractionSource
import androidx.compose.material.RadioButton
import androidx.compose.material.RadioButtonColors
import androidx.compose.material.RadioButtonDefaults
import androidx.compose.runtime.Composable
import androidx.compose.ui.Modifier
import org.jetbrains.compose.ui.tooling.preview.Preview

@Composable
fun AppRadioButton(
    selected: Boolean,
    onClick: (() -> Unit)?,
    modifier: Modifier = Modifier,
    enabled: Boolean = true,
    interactionSource: MutableInteractionSource? = null,
) {
    RadioButton(
        selected,
        onClick,
        modifier,
        enabled,
        interactionSource,
        colors = RadioButtonDefaults.colors()
    )
}

@Preview
@Composable
fun AppRadioButtonPreview() {
}